import React, { useEffect, useState } from "react";

import DropPopup from "../../../components/DropPopup";
import { Modal } from "../../../components/modal/Modal";
import { IMPORT_FILE_TYPES_HINT } from "../import/contactImport.utils";
import { ContactTypeCard } from "./addContact/components/ContactTypeCard";
import { ADD_CONTACT_MODAL_WIDTH } from "./addContact/model/addContact.constants";
import { AddContactType } from "./addContact/model/addContact.types";

interface IImportContactsProps {
  isOpen: boolean;
  closeModal: () => void;
  handleImport: (file: File, variant: AddContactType) => void;
}

const IMPORT_CONTACT_OPTIONS: {
  type: AddContactType;
  title: string;
  description: string;
}[] = [
  {
    type: "individual",
    title: "Individual",
    description: "Import people, spouses and dependants",
  },
  {
    type: "organization",
    title: "Organization",
    description: "Import businesses, trusts and other organizations",
  },
];

// The templates mark required columns with * (Roadmap 1797).
// QA batch 15 (CONT-033): say which files work (the server reads CSV only).
const getImportHint = (type: AddContactType): string => {
  return `${IMPORT_FILE_TYPES_HINT} ${
    type === "individual"
      ? "Columns marked * are required: FirstName and LastName."
      : "Columns marked * are required: CompanyName."
  }`;
};

const getImportTitle = (type: AddContactType): string => {
  return type === "individual"
    ? "Import contacts"
    : "Import organization contacts";
};

const ImportContacts: React.FC<IImportContactsProps> = ({
  isOpen,
  closeModal,
  handleImport,
}) => {
  const [selectedType, setSelectedType] = useState<AddContactType | null>(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedType(null);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  if (selectedType) {
    return (
      <Modal onClose={() => setSelectedType(null)} width={"548px"}>
        <div className={"-m-6 overflow-hidden rounded-2xl"}>
          <DropPopup
            title={getImportTitle(selectedType)}
            message={getImportHint(selectedType)}
            withTemplate={true}
            close={closeModal}
            onFileDrop={(file) => handleImport(file, selectedType)}
            variant={selectedType}
            accept={".csv,text/csv"}
          />
        </div>
      </Modal>
    );
  }

  return (
    <Modal onClose={closeModal} width={ADD_CONTACT_MODAL_WIDTH}>
      <div className={"relative py-6"}>
        <button
          type={"button"}
          className={
            "close-popup absolute -right-2 -top-2 flex h-4 w-4 cursor-pointer items-center justify-center"
          }
          onClick={closeModal}>
          <img src={"/img/closse.png"} alt={"Close"} />
        </button>

        <div className={"grid grid-cols-2 gap-4"}>
          {IMPORT_CONTACT_OPTIONS.map((option) => (
            <ContactTypeCard
              key={option.type}
              type={option.type}
              title={option.title}
              description={option.description}
              onSelect={setSelectedType}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ImportContacts;
